__turbopack_context__.v({
  "wrapper": "snI7UG_wrapper",
});
